import { render, staticRenderFns } from "./EscapeIn.vue?vue&type=template&id=2f3bf8e4&scoped=true"
import script from "./EscapeIn.vue?vue&type=script&lang=js"
export * from "./EscapeIn.vue?vue&type=script&lang=js"
import style0 from "./EscapeIn.vue?vue&type=style&index=0&id=2f3bf8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3bf8e4",
  null
  
)

export default component.exports